import * as c from '@Organizations/Workspaces/Domain/commands-vue-composables'
import * as q from '@Organizations/Workspaces/Domain/queries-vue-composables'

export function useAdminEditWorkspacePage(){
	return {
		useDeleteWorkspaceCommand: c.useDeleteWorkspaceCommandV1,
		useUpdateWorkspaceCommand: c.useUpdateWorkspaceCommandV1,
		useWorkspaceDetailsQuery: q.useWorkspaceDetailsQueryV1,
	}
}

